'use client';

import React, { useEffect, useState } from 'react';

import { motion } from 'framer-motion';

interface BarData {
  label: string;
  value: number;
  color: string;
  borderColor: string;
}

const DATA: BarData[] = [
  {
    label: 'Bioinfometrics',
    value: 0.8,
    color: 'bg-green-700 dark:bg-green-500',
    borderColor: 'border-green-800 dark:border-green-600'
  },
  {
    label: 'Academia',
    value: 0.5,
    color: 'bg-green-600 dark:bg-green-400',
    borderColor: 'border-green-700 dark:border-green-500'
  },
  {
    label: 'Media',
    value: 0.3,
    color: 'bg-purple-600 dark:bg-purple-400',
    borderColor: 'border-purple-700 dark:border-purple-500'
  }
];

const CustomBar: React.FC<{ data: BarData }> = ({ data }) => {
  return (
    <motion.div
      initial={{ clipPath: 'inset(0 100% 0 0)', opacity: 0 }}
      animate={{ clipPath: 'inset(0 0% 0 0)', opacity: 1 }}
      transition={{ duration: 0.8, ease: 'backOut', delay: 0.1 }}
      style={{ width: `${data.value * 100}%` }}
      whileHover={{ scale: 1.02, x: 10 }}
      className='group flex h-14 w-full cursor-pointer items-center overflow-hidden font-bold text-white shadow-xl transition-transform sm:h-20 md:h-24'>
      <div
        className={`flex h-full w-full items-center justify-start rounded-r-3xl pr-4 ${data.color} ${data.borderColor} relative overflow-hidden border-r-8 border-b-8`}>
        <div className='absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 transition-opacity group-hover:opacity-100' />
        <span className='ml-4 truncate text-lg tracking-tight drop-shadow-md sm:ml-6 sm:text-2xl md:text-3xl'>
          {data.label}
        </span>
      </div>
    </motion.div>
  );
};

const Chart: React.FC = () => {
  return (
    <div className='w-full max-w-full'>
      <div className='flex w-full flex-col items-end gap-2 sm:gap-3 md:gap-4'>
        {DATA.map((data, index) => (
          <CustomBar
            key={index}
            data={data}
          />
        ))}
      </div>
    </div>
  );
};

export default Chart;
